import './style.scss';
import {
  PurchaseOption,
  FirstYearDeductionRate,
  FinalBusinessProfitRate,
  HoldingPeriod,
  OverseasRealEstateInitialYearExpenseRate,
} from '../fullInfo';
import { SymbolDetailInfo, OverseasRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
import { JPDateFormatType, formatJPDate, formatYenBasedOn10KYen } from 'views/utils/converter';
import React from 'react';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
export type LeaseFundHalfInfoProps = {
  firstDivision: string;
  secondDivision: string;
  firstInclusion: string;
  secondInclusion: string;
  leasingDate: string;
  minInvestment: string;
};

export const LeaseFundHalfInfo = (symbolDetail: SymbolDetailInfo) => {
  const regex = /\d{1,2}日/g;
  return (
    <div className="leaseFund">
      <div className="halfInfo">
        <div className="halfInfo_row">
          <LeaseFundMainLabel
            head="損益分配日"
            dataList={symbolDetail.PaLDistMonth.map((m) => `${m}${!regex.test(m) ? '末日' : ''}`)}
          />
          <LeaseFundMainLabel
            head="最低出資額"
            dataList={[formatYenBasedOn10KYen(symbolDetail.MinimumInvestmentAmount)]}
          />
        </div>
        <div className="halfInfo_row">
          <LeaseFundSubLabel
            head="リース開始日"
            data={formatJPDate(symbolDetail.LeaseStartDate, JPDateFormatType.YMD)}
          />
        </div>
        <FirstYearDeductionRate {...symbolDetail} />
        <PurchaseOption {...symbolDetail} />
      </div>
    </div>
  );
};

type LeaseFundMainLabelProps = {
  head: string | React.ReactNode;
  dataList: string[];
};

const LeaseFundMainLabel = ({ head, dataList }: LeaseFundMainLabelProps) => {
  return (
    <div className="mainLabel">
      <span className="mainLabel_head">{head}</span>
      <div className="mainLabel_data">
        {dataList.map((data) => (
          <div>{data}</div>
        ))}
      </div>
    </div>
  );
};
type LeaseFundSubLabelProps = {
  head: string;
  data: string;
};
const LeaseFundSubLabel = ({ head, data }: LeaseFundSubLabelProps) => {
  return (
    <div className="subLabel">
      <span className="subLabel_head">{head}</span>
      <div className="subLabel_data">{data}</div>
    </div>
  );
};

export const DomesticRealEstateHalfInfo = (symbolDetail: DomesticRealEstateSymbolDetailInfo) => {
  return (
    <div className="domesticRealEstate">
      <div className="halfInfo">
        <div className="mainLabel">
          <DomesticRealEstateMainLabel
            headList={['所在地', '（住居表示）']}
            dataList={symbolDetail.Location!.split('\n')}
          />
          <DomesticRealEstateMainLabel headList={['築年月']} dataList={symbolDetail.BuiltYear!.split('\n')} />
        </div>
      </div>
    </div>
  );
};

type DomesticRealEstateMainLabelProps = {
  headList: string[];
  dataList: string[];
};

type DomesticRealEstateSubLabelProps = {
  data: string;
};

const DomesticRealEstateMainLabel = ({ headList, dataList }: DomesticRealEstateMainLabelProps) => {
  return (
    <div className="mainLabel_row">
      <div className="mainLabel_row_head">
        {headList.map((head) => (
          <div>{head}</div>
        ))}
      </div>
      <div className="mainLabel_row_data">
        {dataList.map((data) => (
          <div>{data}</div>
        ))}
      </div>
    </div>
  );
};
const DomesticRealEstateSubLabel = ({ data }: DomesticRealEstateSubLabelProps) => {
  return (
    <div className="subLabel">
      <div className="subLabel_data">{data}</div>
    </div>
  );
};

export type OverseasRealEstateHalfInfoProps = {
  firstDivision: string;
  secondDivision: string;
  firstInclusion: string;
  secondInclusion: string;
  leasingDate: string;
  minInvestment: string;
};

export const OverseasRealEstateHalfInfo = (symbolDetail: OverseasRealEstateSymbolDetailInfo) => {
  const regex = /\d{1,2}日/g;
  return (
    <div className="overseasRealEstate">
      <div className="halfInfo">
        <div className="halfInfo_row">
          <OverseasRealEstateMainLabel
            head="損益分配日"
            dataList={symbolDetail.PaLDistMonth.map((m) => `${m}${!regex.test(m) ? '末日' : ''}`)}
          />
          <OverseasRealEstateMainLabel
            head="最低出資額"
            dataList={[formatYenBasedOn10KYen(symbolDetail.MinimumInvestmentAmount)]}
          />
        </div>
        <div className="halfInfo_row">
          <OverseasRealEstateSubLabel
            head="事業開始日"
            data={formatJPDate(symbolDetail.BusinessStartDate, JPDateFormatType.YMD)}
          />
        </div>
        <OverseasRealEstateInitialYearExpenseRate {...symbolDetail} />
        <FinalBusinessProfitRate {...symbolDetail} />
        <HoldingPeriod {...symbolDetail} />
      </div>
    </div>
  );
};

type OverseasRealEstateMainLabelProps = {
  head: string | React.ReactNode;
  dataList: string[];
};

const OverseasRealEstateMainLabel = ({ head, dataList }: OverseasRealEstateMainLabelProps) => {
  return (
    <div className="mainLabel">
      <span className="mainLabel_head">{head}</span>
      <div className="mainLabel_data">
        {dataList.map((data) => (
          <div>{data}</div>
        ))}
      </div>
    </div>
  );
};
type OverseasRealEstateSubLabelProps = {
  head: string;
  data: string;
};
const OverseasRealEstateSubLabel = ({ head, data }: OverseasRealEstateSubLabelProps) => {
  return (
    <div className="subLabel">
      <span className="subLabel_head">{head}</span>
      <div className="subLabel_data">{data}</div>
    </div>
  );
};
